/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable curly */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-restricted-globals */
/* eslint-disable radix */
import React, { useState, useEffect } from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { makeApi, URLS } from 'Utils/apiUtil';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { userDetail } from 'Stores/userDetail';
import CsvExportIcon from 'Assets/png/export_icons/csv_export.png';
import SalesforceExportIcon from 'Assets/png/export_icons/salesforce_export.png';
import { loginValidate } from 'Utils/commonApi';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import companySearchState from 'Stores/companySearch';
import {
  OwnershipMappingPopup,
  ownershipMappingState,
} from 'Components/common/ExportLeads/ownershipMapping';
import crmIntegrationState from 'Stores/crmIntegration';

const { CONTACT_EXPORT_TYPES } = CONSTANTS;
const {
  DIRECT_EXPORT,
  // ASYNC_EXPORT,
  // ASYNC_EXPORT_CRITERIA,
} = CONTACT_EXPORT_TYPES;

const { COMPANY_EXPORT_TYPE, CRM_EXPORT_TYPE } = CONSTANTS;

const exportOptionList = [COMPANY_EXPORT_TYPE.CSV, CRM_EXPORT_TYPE.SALESFORCE];

const exportOptionCls = ['csv-icon', 'salesforce-icon'];

const exportOptionIcons = [CsvExportIcon, SalesforceExportIcon];

const defaultExportMxData = {
  pageType: 'AS', // AS/ML
  searchType: 'COMPANY',
};
class ExportCompaniesState {
  @observable exportOption = '';

  @observable callBack;

  @observable showCrmExportOptions = false;

  @observable showProcessingExport = false;

  @observable exportPostData = {};

  @observable exportMxData = defaultExportMxData;

  @action
  setExportOption = val => {
    this.exportOption = val;
  };

  @action
  setShowCrmExportOptions = val => {
    this.showCrmExportOptions = val;
  };

  @action
  setExportPostData = (val = {}) => {
    this.exportPostData = val;
  };

  @action
  setExportMxData = (val = defaultExportMxData) => {
    this.exportMxData = { ...this.exportMxData, ...val };
  };

  @action
  setShowProcessingExport = value => {
    this.showProcessingExport = value;
  };

  @action
  checkAndexport = (
    selectedType,
    source,
    exportOption = 'export selected',
    isExportEnabled,
  ) => {
    const thisObj = this;
    this.exportPostData = {};

    if (!isExportEnabled) {
      Utils.mixpanelTrack(
        CONSTANTS.MX_LB_EXPORT_EVENTS.LB_CLICK_EXPORT_UPGRADE,
        {
          exportType: selectedType,
          ...thisObj.exportMxData,
        },
      );
      if (selectedType === COMPANY_EXPORT_TYPE.CSV)
        Utils.showUserPricingPopup(true, 'csv_export', false);
      else Utils.showUserPricingPopup(true, 'crm_export', false);
    }

    if (isExportEnabled) {
      Utils.mixpanelTrack(
        CONSTANTS.MX_LB_EXPORT_EVENTS.LB_CLICK_SELECT_EXPORT_TYPE,
        { exportType: selectedType, ...thisObj.exportMxData },
      );
      if (selectedType === 'CSV') {
        this.exportCompaniesToCSV(selectedType, source, exportOption);
      } else if (selectedType === 'Salesforce') {
        this.exportCompaniesToSalesforce();
      }
    }
  };

  @action
  exportCompaniesMakeApiCall = (apiUrl, callBack) => {
    const config = {
      url: apiUrl,
      method: 'POST',
      data: this.exportPostData,
    };
    const thisObj = this;
    makeApi(config)
      .then(response => {
        callBack(response);
      })
      .catch(error => {
        console.log('exportCompaniesMakeApiCall error ', error);
      });
  };

  @action
  constructExportStatusPopup = (
    statusType = 'Success',
    result,
    selectedSrc = '',
    customMsg,
  ) => {
    companySearchState.clearAllSelection();
    let msgStr = '';
    const emptyCbk = () => {};
    let exportStatusType = statusType;
    if (customMsg !== undefined && customMsg !== '') {
      msgStr = customMsg;
    } else {
      const {
        exportSuccessCount,
        newDownloadedCount,
        exportFailedCount,
        duplicateCompanyCount,
        errorType,
        creditsReduced,
      } = result || '';
      const successMsg =
        exportSuccessCount && exportSuccessCount > 1
          ? `${exportSuccessCount} Companies`
          : `${exportSuccessCount} Company`;
      const failedMsg =
        exportFailedCount && exportFailedCount > 1
          ? `${exportFailedCount} Companies`
          : `${exportFailedCount} Company`;

      const duplicateMsg =
        duplicateCompanyCount && duplicateCompanyCount > 1
          ? `${duplicateCompanyCount} Companies`
          : `${duplicateCompanyCount} Company`;

      let detectedCount = 0;
      let creditType = 'download';
      if (Utils.isCreditBasedSubscription()) {
        creditType = 'credit';
        detectedCount = creditsReduced && parseInt(creditsReduced);
      } else {
        detectedCount = newDownloadedCount && parseInt(newDownloadedCount);
      }

      if (exportSuccessCount > 0 || duplicateCompanyCount > 0) {
        exportStatusType = 'Success';
        if (exportSuccessCount > 0)
          msgStr = `${successMsg} exported successfully. <br/>
                ${detectedCount === 0 ? 'No' : detectedCount} ${creditType}${
            detectedCount > 1 ? 's' : ''
          } deducted. <br/>`;
        msgStr +=
          exportFailedCount > 0 ? `${failedMsg} export failed. <br/>` : '';

        msgStr +=
          duplicateCompanyCount > 0
            ? ` ${duplicateMsg} not exported as they already exist in your ${selectedSrc} account.`
            : '';

        Utils.mixpanelTrack(
          CONSTANTS.MX_LB_EXPORT_EVENTS.LB_VIEW_EXPORT_SUCCESS,
          {
            exportType: selectedSrc,
            message: msgStr,
            ...this.exportMxData,
          },
        );
      } else {
        Utils.mixpanelTrack(
          CONSTANTS.MX_LB_EXPORT_EVENTS.LB_VIEW_EXPORT_FAILED,
          {
            exportType: selectedSrc,
            reason:
              customMsg !== undefined && customMsg !== '' ? customMsg : '',
            ...this.exportMxData,
          },
        );
        exportStatusType = 'Failed';

        msgStr = `An error occured while exporting the ${failedMsg}. Please try again or contact <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a>.`;
      }
    }
    confirmationPopupState.setPopupValues({
      title: `${selectedSrc} Export ${exportStatusType}`,
      content: msgStr,
      actionBtnText: 'OK',
      needCancelBtn: false,
      callback: emptyCbk,
    });
    this.showProcessingExport = false;
    confirmationPopupState.setShowPopup(true);
  };

  @action
  exportCompaniesToCSV = (type, source, option) => {
    let exportCompanyCount = 1;
    let exportCsvUrl = URLS.companyExport.exportSelectedCompaniesToCSV;
    if (companySearchState.hugeSelectionBulkIds.length > 0) {
      exportCompanyCount = companySearchState.hugeSelectionBulkIds.length;
      this.exportPostData = {
        ...companySearchState.bulkSelectionPostData,
      };
      exportCsvUrl = URLS.companyExport.exportBulkCompaniesToCSV;
    } else {
      exportCompanyCount = companySearchState.bulkPurchaseIds.length;
      this.exportPostData = {
        companyIds: companySearchState.bulkPurchaseIds,
      };
    }
    this.exportCompaniesToCSVFlow(exportCompanyCount, exportCsvUrl);
  };

  @action
  exportCompaniesToSalesforce = accountOwners => {
    const exportSalesforceUrl = Utils.generateUrl(URLS?.crmExport?.export, {
      crmType: 'SALESFORCE',
      type: DIRECT_EXPORT,
      source: 'ADVANCED_SEARCH',
    });

    const companyIds =
      companySearchState.hugeSelectionBulkIds.length > 0
        ? companySearchState.hugeSelectionBulkIds
        : companySearchState.bulkPurchaseIds;

    if (companyIds.length > companySearchState.salesforceExportMaxLimit) {
      this.exportFailureLimit();
      return;
    }
    this.showProcessingExport = true;
    this.exportPostData = {
      companyIds: JSON.stringify(
        companySearchState.hugeSelectionBulkIds.length > 0
          ? companySearchState.hugeSelectionBulkIds
          : companySearchState.bulkPurchaseIds,
      ),
      exportSource: 'advancedSearch',
      export_type: 'Salesforce',
      isEu: false,
      now: Date.now(),
      requestType: 'DIRECT_EXPORT',
      source: 'salesLift',
      isCompanyExport: true,
    };
    const salesforceExportCallback = res => {
      this.showProcessingExport = false;
      this.exportCompaniesToCrmResponseHandler(res, 'Salesforce');
    };
    const { exportPostData } = this;
    if (accountOwners !== undefined && accountOwners !== '')
      exportPostData.accountOwners = accountOwners;

    this.exportPostData = exportPostData;
    this.exportCompaniesMakeApiCall(
      exportSalesforceUrl,
      salesforceExportCallback,
    );
  };

  @action
  assignOwnerShipToSalesforce = () => {
    const thisObj = this;
    const assignedOwners = postData => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_LB_EXPORT_EVENTS.LB_SF_EXPORT_ASSIGN_OWNERS,
        {
          isAllowed: 'Yes',
          ...thisObj.exportMxData,
        },
      );
      thisObj.exportCompaniesToSalesforce(postData);
    };
    const withoutAssignOwners = () => {
      Utils.mixpanelTrack(
        CONSTANTS.MX_LB_EXPORT_EVENTS.LB_SF_EXPORT_ASSIGN_OWNERS,
        {
          isAllowed: 'Yes',
          ...thisObj.exportMxData,
        },
      );
      thisObj.exportCompaniesToSalesforce({});
    };
    ownershipMappingState.setExportType('Salesforce');
    ownershipMappingState.setExportSource(
      CONSTANTS.EXPORT_SOURCE.ADVANCED_SEARCH,
    );
    ownershipMappingState.setPostData(this.exportPostData);
    ownershipMappingState.setExportCallback(assignedOwners);
    ownershipMappingState.setCancelCallback(withoutAssignOwners);
    ownershipMappingState.setCompanyExport(true);
    ownershipMappingState.setShowPopup(true);
  };

  @action
  askAssignOwnerShipPopup = exportType => {
    const thisObj = this;
    const assignOwnerShipCallback = () => {
      if (exportType === 'Salesforce') thisObj.assignOwnerShipToSalesforce();
    };
    const donotAssignOwnerShipCallback = () => {
      if (exportType === 'Salesforce') {
        Utils.mixpanelTrack(
          CONSTANTS.MX_LB_EXPORT_EVENTS.LB_SF_EXPORT_ASSIGN_OWNERS,
          {
            isAllowed: 'No',
            ...thisObj.exportMxData,
          },
        );
        thisObj.exportCompaniesToSalesforce({});
      }
    };
    const assignOwnerText = 'Do you want to assign owners to these accounts?';
    confirmationPopupState.setPopupValues({
      title: `Export ${
        thisObj.exportPostData.save_type ? thisObj.exportPostData.save_type : ''
      } to ${exportType} `,
      content: assignOwnerText,
      actionBtnText: 'Yes',
      customClassName: 'ask-assign-owners',

      callback: assignOwnerShipCallback,
      actionBtnTextCancel: 'No, Continue to Export',
      cancelCallback: donotAssignOwnerShipCallback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  @action
  showPreferencePopUp = () => {
    this.askAssignOwnerShipPopup('Salesforce');
  };

  @action
  exportCompaniesToCrmResponseHandler = (res, crmType) => {
    const thisObj = this;
    if (res && res.data) {
      const response = res.data;
      const crmTypeVal = crmType && thisObj.exportPostData.export_type;
      const { responseCode = '', responseData } = response;
      switch (responseCode) {
        case 303:
        case 412:
        case 407:
          crmIntegrationState.setShowConnectErrorMsg({
            showPopup: true,
            crmType: crmTypeVal,
            ...response,
            ...responseData,
            redirectToIntegrations: responseCode === 303,
          });
          break;
        case 417: {
          const { inputRequired } = responseData;
          if (inputRequired === 'ACCOUNT_OWNERS')
            this.askAssignOwnerShipPopup(crmTypeVal);
          if (inputRequired === 'CRM_PREFERENCES')
            if (crmType === CRM_EXPORT_TYPE.SALESFORCE)
              this.showPreferencePopUp(crmType);
          break;
        }
        case 200:
          {
            const {
              duplicateCount,
              failedCount,
              newlyAddedCount,
              successCount,
              totalCount,
              isCreditLimitExhausted = false,
            } = response || {};

            const resData = {
              responseCode: 200,
              exportSuccessCount: successCount,
              newDownloadedCount: newlyAddedCount,
              exportFailedCount: failedCount,
              duplicateCompanyCount: duplicateCount,
              creditsReduced: newlyAddedCount,
              totalCount,
              isCreditLimitExhausted,
            };
            this.constructExportStatusPopup('Success', resData, crmType);
            loginValidate();
            companySearchState.updateSelectedBulkContactAll(true);
          }
          break;
        case 402:
        case 426:
        case 430: {
          const { userInfo } = userDetail;
          const { memberSubscription } = userInfo;
          if (memberSubscription !== null && memberSubscription !== undefined) {
            if (Utils.isFreeTrialPlan())
              userDetail.setShowUpgradeCreditPopup(true);
            else
              Utils.showCreditExpiredPopup(
                'downloads',
                null,
                responseCode === 430,
              );
          } else {
            Utils.showUserPricingPopup(true, 'downloads', false);
          }
          this.showProcessingExport = false;
          companySearchState.updateSelectedBulkContactAll(true);
          break;
        }
        default:
          this.constructExportStatusPopup('Failed', {}, crmType);
          break;
      }
    } else {
      this.constructExportStatusPopup('Failed', {}, crmType);
    }
  };

  @action
  exportCompaniesResponseHandler = (res, exportType) => {
    const thisObj = this;

    if (res && res.data) {
      const response = res.data;
      if (response.responseCode === 200) {
        const exportTypeVal =
          exportType !== undefined
            ? exportType
            : thisObj.exportPostData.export_type;
        if (exportTypeVal === 'CSV')
          Utils.downloadToCsv(
            response,
            `AdaptCompanyExport-${Utils.getExportDateString()}`,
          );

        companySearchState.updateSelectedBulkContactAll(true);
        this.constructExportStatusPopup('Success', response, exportType);
        loginValidate();
      } else if (response.error === 'limit') {
        this.showProcessingExport = false;
        companySearchState.updateSelectedBulkContactAll(true);
        const errorMsg =
          'Sorry, you can download max of 2000 companies per transaction.';
        this.constructExportStatusPopup('Failed', {}, exportType, errorMsg);
        companySearchState.updateSelectedBulkContactAll(true);
        this.showProcessingExport = false;
      } else if (
        response.responseCode === 101 ||
        response.responseCode === 105 ||
        response.error === 'subscription' ||
        response.errorType === 'subscription'
      ) {
        if (Utils.isFreeTrialPlan()) {
          userDetail.setShowUpgradeCreditPopup(true);
        } else if (
          userDetail.userInfo.memberSubscription !== null &&
          userDetail.userInfo.memberSubscription !== undefined
        ) {
          Utils.showCreditExpiredPopup('downloads');
        } else {
          Utils.showUserPricingPopup(true, 'downloads', false);
        }
        companySearchState.updateSelectedBulkContactAll(true);
        this.showProcessingExport = false;
      } else if (
        response.responseCode === 500 &&
        response.exportSuccessCount &&
        parseInt(response.exportSuccessCount) > 0 &&
        response.exportFailedCount &&
        parseInt(response.exportFailedCount) > 0
      ) {
        const errorMsg = `We were able to export only ${parseInt(
          response.exportSuccessCount,
        )} companies to ${exportType}. Please try again to export the remaining companies.`;
        this.constructExportStatusPopup('Failed', {}, exportType, errorMsg);
        companySearchState.updateSelectedBulkContactAll(true);
      } else if (response.responseCode === 500) {
        if (response.errorMsg !== null && response.errorMsg !== undefined) {
          this.constructExportStatusPopup(
            'Failed',
            {},
            exportType,
            response.errorMsg,
          );
        } else {
          this.constructExportStatusPopup('Failed', {}, exportType);
        }
        companySearchState.updateSelectedBulkContactAll(true);
      } else {
        this.constructExportStatusPopup('Failed', {}, exportType);
        companySearchState.updateSelectedBulkContactAll(true);
      }
    } else {
      this.constructExportStatusPopup('Failed', {}, exportType);
      companySearchState.updateSelectedBulkContactAll(true);
    }
  };

  @action
  exportCompaniesToCSVFlow = (exportCompanyCount, exportCsvUrl) => {
    const thisObj = this;

    this.showProcessingExport = true;

    const csvExportCallback = res => {
      this.exportCompaniesResponseHandler(res, 'CSV');
    };

    this.exportCompaniesMakeApiCall(exportCsvUrl, csvExportCallback);
  };

  @action
  exportFailureLimit = (str, exportCompanyCount) => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_LB_EXPORT_EVENTS.LB_VIEW_EXPORT_LIMIT_EXCEED,
      {
        exportType: str,
        triedLimit: exportCompanyCount,
        currentLimit: companySearchState.salesforceExportMaxLimit,
        ...this.exportMxData,
      },
    );
    const emptyCbk = () => {};
    confirmationPopupState.setPopupValues({
      title: 'Limit Exceeded',
      content: `You can export a maximum of ${companySearchState.salesforceExportMaxLimit} companies to your Salesforce CRM in a single transaction.`,
      actionBtnText: 'OK',
      needCancelBtn: false,
      callback: emptyCbk,
    });
    confirmationPopupState.setShowPopup(true);
  };
}

const exportCompaniesState = new ExportCompaniesState();

const ExportCompanies = observer(props => {
  const { dropboxClickCallback = () => {} } = props;

  const { featureFlags } = userDetail;
  const {
    COMPANY_CSV_EXPORT = false,
    COMPANY_CRM_EXPORT = false,
  } = featureFlags;

  const selectExportType = (exportType, isExportEnabled) => {
    exportCompaniesState.checkAndexport(
      exportType,
      'salesLift',
      'export selected',
      isExportEnabled,
    );
    exportCompaniesState.setShowCrmExportOptions(false);
  };

  return (
    <>
      <OwnershipMappingPopup searchType="COMPANY" />

      {exportCompaniesState.showCrmExportOptions && (
        <>
          <div className="export-leads-popup common-popup">
            <div className="popup-wrap">
              <div
                className="popup-close"
                title="Click here to close"
                onClick={() =>
                  exportCompaniesState.setShowCrmExportOptions(false)
                }
              >
                <CloseIcon />
              </div>
              <div className="title">Export Companies</div>
              <div className="popup-content-wrap">
                {exportOptionList.map((item, index) => {
                  return item === 'CSV' ? (
                    <div
                      className={`export-optin-item${
                        COMPANY_CSV_EXPORT ? '' : ' blocked-wrap'
                      }`}
                      key={`export-option-${index}`}
                      onClick={e => selectExportType(item, COMPANY_CSV_EXPORT)}
                    >
                      {COMPANY_CSV_EXPORT === false && (
                        <LockIcon className="dropdown-icon plus-icon lock-icon" />
                      )}
                      <div className="option-icon-wrap">
                        <img
                          className={`option-icon ${exportOptionCls[index] &&
                            exportOptionCls[index]}`}
                          src={exportOptionIcons[index]}
                          alt={item}
                        />
                      </div>
                      <div className="option-title">{item}</div>
                    </div>
                  ) : (
                    <div
                      className={`export-optin-item${
                        COMPANY_CRM_EXPORT ? '' : ' blocked-wrap'
                      }`}
                      key={`export-option-${index}`}
                      onClick={e => selectExportType(item, COMPANY_CRM_EXPORT)}
                    >
                      {COMPANY_CRM_EXPORT === false && (
                        <LockIcon className="dropdown-icon plus-icon lock-icon" />
                      )}
                      <div className="option-icon-wrap">
                        <img
                          className={`option-icon ${exportOptionCls[index] &&
                            exportOptionCls[index]}`}
                          src={exportOptionIcons[index]}
                          alt={item}
                        />
                      </div>
                      <div className="option-title">{item}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div
            className="common-popup-mask"
            onClick={() => exportCompaniesState.setShowCrmExportOptions(false)}
          />
        </>
      )}
    </>
  );
});

export { ExportCompanies, exportCompaniesState };
export default ExportCompanies;
